import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import App from '@/app';
import { AppErrorFallback } from '@/app-error-fallback';

const Root = () => (
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error }) => <AppErrorFallback error={error} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
Root.displayName = 'Root';

export default Root;
